import {API_DRIVER} from "../configs/axios";

export const ThresholdService = {
    fetchThresholdData: (integrationId, page, size, sortBy, sortOrder, type,
                         msisdn, name, state, service) => {
        return API_DRIVER.get(`/api/threshold`, {
            params: {
                integrationId,
                page,
                size,
                sortBy,
                sortOrder,
                type: type.length ? type : undefined,
                msisdn: msisdn.length ? msisdn : undefined,
                name: name.length ? name : undefined,
                state: state.length ? state : undefined,
                service: service.length ? service : undefined
            }
        })
    },
    fetchThresholdDetails: (ruleId, integrationId) => {
        return API_DRIVER.get(`/api/threshold/${ruleId}/integrationId/${integrationId}`)
    },
    fetchAddSimToRuleData: (ruleId, integrationId) => {
        return API_DRIVER.get(`/api/threshold/${ruleId}/to-enroll-sims/integrationId/${integrationId}`)
    },
    addSimToRule: (ruleId, integrationId, selectedSims) => {
        return API_DRIVER.post(`/api/threshold/${ruleId}/enroll-sim/integrationId/${integrationId}`, selectedSims)
    },
    fetchSimsToDelete: (ruleId, integrationId) => {
        return API_DRIVER.get(`/api/threshold/${ruleId}/to-delete-sims/integrationId/${integrationId}`)
    },
    deleteSelectedSims: (ruleId, integrationId, selectedSims) => {
        return API_DRIVER.post(`/api/threshold/${ruleId}/delete-sim/integrationId/${integrationId}`, selectedSims)
    },
    createNewRule: (createRuleDto, integrationId) => {
        return API_DRIVER.post(`/api/threshold/rule/integrationId/${integrationId}`, createRuleDto)
    },
    fetchSimsToAssociateNewRule: (integrationId) => {
        return API_DRIVER.get(`/api/threshold/create-rule/get-associate-sims/integrationId/${integrationId}`)
    },
    updateRule: (ruleId, integrationId, updateRuleRequestDto) => {
        return API_DRIVER.patch(`/api/threshold/${ruleId}/integrationId/${integrationId}`, updateRuleRequestDto)
    },
    deleteRules: (integrationId, ruleIds) => {
        const body = {
            ruleIds: ruleIds
        }
        return API_DRIVER.post(`/api/threshold/delete-rules/integrationId/${integrationId}`, body)
    },
    deleteThresholds: (ruleId, integrationId, thresholdIds) => {
        const body = {
            thresholdIds: thresholdIds
        }
        return API_DRIVER.post(`/api/threshold/${ruleId}/delete-thresholds/integrationId/${integrationId}`, body)
    },
    addThresholdsToRule: (ruleId, integrationId, thresholds) => {
        return API_DRIVER.post(`/api/threshold/rule/${ruleId}/integrationId/${integrationId}`, thresholds)
    },
    updateThresholdsForRule: (ruleId, integrationId, thresholds) => {
        return API_DRIVER.post(`/api/threshold/${ruleId}/threshold-update-requests/integrationId/${integrationId}`, thresholds)
    },
    fetchCreateRegolaMenuItems: (ruleType, unitType, service, traffic, period) => {
        return API_DRIVER.get(`/api/threshold/create-rule-options`, {
            params: {
                ruleType: ruleType.trim() || null,
                unitType: unitType.trim() || null,
                service: service.trim() || null,
                traffic: traffic.trim() || null,
                period: period.trim() || null
            }
        })
    },
    fetchSoglieAddRemoveSimCollaboratorsFilter: (integrationId) => {
        return API_DRIVER.get(`/api/threshold/filter/add-remove-sim/collaborators/company/${integrationId}`)
    }
}
